import { ListItem, ListItemText } from "@material-ui/core";

import LongText from "./LongText";
import React from "react";

const FileItem = ({ name, path, sub, maxWidth }) => (
  <ListItem key={name} button dense component="a" target="_blank" href={path}>
    <ListItemText
      primary={<LongText value={name} maxWidth={maxWidth} />}
      secondary={<LongText value={sub} maxWidth={maxWidth} />}
    />
  </ListItem>
);

export default FileItem;
